import { House } from '@model/house';
import { Globals } from '@theme/utils/globals';
import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AuthService } from '@service/auth/auth.service';
import {HouseService} from '@service/house/house.service';
import {EmitterService} from '@service/emitter/emitter.service';
import { NoticeService } from '@service/notice/notice.service';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-impression-groupee',
  templateUrl: './impression-groupee.component.html',
  styleUrls: ['./impression-groupee.component.scss']
})
export class ImpressionGroupeeComponent implements OnInit {
  title?: string
  user: any;
  form: FormGroup;
  submit = false;
  edit = false;
  dtOptions: any = {};
  house: House;
  options: any[] = []
  userSession = Globals.user
  houseSelected?: any;
  constructor(
    private auth: AuthService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    public modalActive: NgbActiveModal,
    private emitter: EmitterService,
    private noticeService: NoticeService,
    private houseService: HouseService,
  ) {
    this.newForm();
    this.edit = this.houseService.edit;
    this.user = this.auth.getDataToken() ? this.auth.getDataToken() : null;
    this.title = "Impression groupée"
  }

  ngOnInit(): void {
    this.dtOptions = Globals.dataTable;
  }

  modal(component, type, size, center, backdrop) {
    this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: center,
      backdrop: backdrop
    }).result.then((result) => { }, (reason) => { });
  }
  onClose(){ this.modalActive.close('ferme'); }

  onSubmit() {
    this.submit = true;
    if (this.form.valid) {
      this.houseService.add(this.form.getRawValue()).subscribe(res => {
        if (res?.status === 'success') {
          this.onClose();
          if (this.form.value.uuid) {
            this.emitter.emit({action: 'CONTRACT_UPDATED', payload: res?.data});
          } else {
            this.emitter.emit({action: 'CONTRACT_ADD', payload: res?.data});
          }
        }
      }, error => {});
    } else {
      return;
    }
  }

  newForm() {
    this.form = this.formBuilder.group({
      periode: [null],
      house: [null],
    })
  }

  editForm(): void {
    if (this.edit) {
      const data = {...this.houseService.getHouse()};
      // this.sethouseUuid(data.house.uuid);
      this.houseSelected = {
        // photoSrc: data.tenant.photoSrc,
        // title: data.house.searchableTitle,
        // detail: data.house.searchableDetail
      };
    }
  }

  onLoadData(){
    this.noticeService.getItems(this.form.value).subscribe(res => {
      if(res){
        this.options = res.data
        return this.options
      }
    });
  }

  sethouseUuid(uuid) {
    if(uuid){
      this.f.house.setValue(uuid);
      this.loadHouse();
    } else {
      this.f.house.setValue(null);
    }
  }

  // sethouseUuid(uuid: string) {
  //   if (this.form && this.form.get('houseUuid')) {
  //     this.form.get('houseUuid')!.setValue(uuid);
  //   } else {
  //     console.error("Le champ 'houseUuid' n'existe pas sur le formulaire.");
  //   }
  // }

  loadHouse() {
    this.emitter.disallowLoading();
    this.houseService.getSingle(this.f.house.value).subscribe((res: any) => {
      this.house = res?.data;
    });
  }

  onConfirme() {
    Swal.fire({
      title: '',
      text: 'Confirmez-vous l\'enregistrement ?',
      icon: 'warning',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Confirmer <i class="fas fa-check"></i>',
      cancelButtonText: 'Annuler <i class="feather icon-x-circle"></i>',
      confirmButtonColor: '#1bc943',
      reverseButtons: true
    }).then((willDelete) => {
      if (!willDelete.dismiss) {
        this.onSubmit();
      }
    });
  }
  print() {
    this.noticeService.getPrinterGroupee(null, this.userSession?.agencyKey, this.userSession?.uuid, this.f.periode.value, this.f.house.value);
    console.log('donnée',this.userSession?.uuid);
  }

  

  get f() { return this.form.controls; }
  get option() { return this.form.get('options') as FormArray; }
}
